__turbopack_context__.v({
  "backgroundImage": "ForClubsRevenueModel-module-scss-module__GjZrIG__backgroundImage",
  "backgroundImageWrapper": "ForClubsRevenueModel-module-scss-module__GjZrIG__backgroundImageWrapper",
  "backgroundMask": "ForClubsRevenueModel-module-scss-module__GjZrIG__backgroundMask",
  "maskSvg": "ForClubsRevenueModel-module-scss-module__GjZrIG__maskSvg",
  "pointsDescription": "ForClubsRevenueModel-module-scss-module__GjZrIG__pointsDescription",
  "pointsIndex": "ForClubsRevenueModel-module-scss-module__GjZrIG__pointsIndex",
  "pointsList": "ForClubsRevenueModel-module-scss-module__GjZrIG__pointsList",
  "pointsRow": "ForClubsRevenueModel-module-scss-module__GjZrIG__pointsRow",
  "pointsTitle": "ForClubsRevenueModel-module-scss-module__GjZrIG__pointsTitle",
  "revenueGrain": "ForClubsRevenueModel-module-scss-module__GjZrIG__revenueGrain",
  "revenueSection": "ForClubsRevenueModel-module-scss-module__GjZrIG__revenueSection",
  "sectionBackground": "ForClubsRevenueModel-module-scss-module__GjZrIG__sectionBackground",
  "sectionEyebrow": "ForClubsRevenueModel-module-scss-module__GjZrIG__sectionEyebrow",
  "sectionTitle": "ForClubsRevenueModel-module-scss-module__GjZrIG__sectionTitle",
});
